import React from 'react';
import { Modal, Button } from 'antd';
import { useTranslation } from '../../../../../../i18n/useTranslation';

type Props = {
    cancelModalVisible?: boolean;
    onDiscard?: () => void;
    onCancel?: () => void;
};

export const DiscardDescriptionModal = ({ cancelModalVisible, onDiscard, onCancel }: Props) => {
    const { t } = useTranslation();
    return (
        <>
            <Modal
                title={t('Exit Editor')}
                visible={cancelModalVisible}
                destroyOnClose
                onCancel={onCancel}
                centered
                footer={[
                    <Button type="text" onClick={onCancel}>
                        {t('Cancel')}
                    </Button>,
                    <Button onClick={onDiscard}>{t('Yes')}</Button>,
                ]}
            >
                <p>{t('Are you sure you want to close the documentation editor? Any unsaved changes will be lost.')}</p>
            </Modal>
        </>
    );
};
